import {CssBaseline, ThemeProvider,} from "@mui/material";
import React from "react";
import "./App.css";
import AppRoute from "./AppRoute";
import {NAMESPACES, resolve} from "./translations/resolve";
import {lexofficeThemeMUI, LxI18N} from "@lxo-blocks/react";
import {LxSnackbarProvider} from "@lxo-blocks/react/Snackbar/LxSnackbarProvider";


export default function App() {
    return (
        <>
            <ThemeProvider theme={lexofficeThemeMUI}>
                <CssBaseline/>
                <LxSnackbarProvider>
                    <LxI18N locale="de-DE" resolver={[resolve]} namespaces={NAMESPACES}>
                        <AppRoute/>
                    </LxI18N>
                </LxSnackbarProvider>
            </ThemeProvider>
        </>
    )
        ;
}
